import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';
import ModalHeaderWithClose from 'components/ModalHeaderWithClose';
import {FormattedMessage, FormattedDate} from 'react-intl';
import Icon from 'components/Icon';
import DateAnnotationsModalItem from './DateAnnotationsModalItem';
import styles from './DateAnnotationsModal.css?module';

class DateAnnotationsModal extends React.Component {
  render() {
    const {isOpen, onRequestModalClose, dateAnnotations} = this.props;

    const annotationDate =
      dateAnnotations.length > 0
        ? new Date(dateAnnotations[0].dataPoint.point1)
        : '';

    return (
      <Modal isOpen={isOpen}>
        <ModalHeaderWithClose onClose={onRequestModalClose}>
          <ModalHeader>
            <Icon
              className={styles.annotationIcon}
              icon={Icon.OPTIONS.ANNOTATION}
              size={Icon.SIZES.NANO}
            />
            <FormattedMessage
              id="DateAnnotationsModal__Header"
              description="Header for annotations modal"
              defaultMessage={`Annotations`}
            />
          </ModalHeader>
        </ModalHeaderWithClose>
        <header className={styles.title}>
          <div className={styles.date}>
            <FormattedDate
              value={annotationDate}
              year="numeric"
              month="short"
              day="numeric"
            />
          </div>
          <div className={styles.subHeader}>
            <FormattedMessage
              id="DateAnnotationsModal__CountOfAnnotations"
              description="A count of the number of annotations associated with this date"
              defaultMessage={`{count} annotations`}
              values={{
                count: dateAnnotations.length,
              }}
            />
          </div>
        </header>
        {dateAnnotations.map(dateAnnotation => (
          <DateAnnotationsModalItem
            key={dateAnnotation.id}
            dateAnnotation={dateAnnotation}
          />
        ))}
      </Modal>
    );
  }
}

DateAnnotationsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestModalClose: PropTypes.func.isRequired,
  dateAnnotations: PropTypes.array.isRequired,
};

export default DateAnnotationsModal;
